import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TShirtEditor from "./pages/TShirtEditor";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<TShirtEditor />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<TShirtEditor />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </CartProvider>
    </div>
  );
}

export default App;
